import React, { ChangeEvent } from 'react';
import { Controller, ControllerRenderProps, FieldValues, useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../../../../components/checkbox';
import { TariffBody } from '../../types';

type CheckboxControllerProps = {
  name: string;
  label: string;
  handleWatchForCustom: (values: TariffBody) => void;
  disabled?: boolean;
};

export const CheckboxController: React.FC<CheckboxControllerProps> = ({
  name,
  label,
  handleWatchForCustom,
  disabled,
}) => {
  const { control, getValues } = useFormContext();

  const handleChange = (e: ChangeEvent<HTMLInputElement>, field: ControllerRenderProps<FieldValues, string>) => {
    field.onChange(e);
    handleWatchForCustom(getValues() as TariffBody);
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Checkbox onChange={(e) => handleChange(e, field)} checked={field.value} reverse disabled={disabled}>
          {label}
        </Checkbox>
      )}
    />
  );
};
